import React, { useContext, useEffect, useState } from 'react';

import { navigate } from '@reach/router';

import { GlobalContext } from '../../../../store';

import { EventWizardStepTitle } from '../Components/EventWizardStepTitle/EventWizardStepTitle';
import { useRouteInfoState } from '../../../../components/RouteInfo/Context/RouteInfo.context';
import { EVENT_SETUP_SECTIONS } from '../EventSetup/Utils/EVENT_SETUP_SECTIONS';
import { useGetAdminEvent } from '../../../../contrib/Hooks/useGetAdminEvent';
import Switch from '../../../../components/YesNoSwitch';
import FlightsSection from './Components/FlightsSection/FlightsSection';
import { typeAction } from './Utils/typeAction';

const EventFlights = () => {
  const {
    actions: {
      adminEvents: { edit: editEvent },
      notifications: { pushError }
    },
    adminRoundFormats: { roundFormats }
  } = useContext(GlobalContext);

  const { clubId, eventId } = useRouteInfoState();

  const event = useGetAdminEvent(eventId);

  const [flightsNotSaved, setFlightsNotSaved] = useState(false);
  const [useFlights, setUseFlights] = useState(false);
  const [displayFlightsForTeams, setDisplayFlightsForTeams] = useState(false);
  const [displayFlightsForIndividuals, setDisplayFlightsForIndividuals] = useState(false);

  useEffect(() => {
    if (eventId) {
      const eventRoundFormats = roundFormats[Number(eventId)];

      if (eventRoundFormats) {
        setDisplayFlightsForTeams(eventRoundFormats.some(format => format.format.teams));
        setDisplayFlightsForIndividuals(eventRoundFormats.some(format => !format.format.teams));
      }
    }
  }, [roundFormats, eventId]);

  const nextStep = () => {
    const nextSectionSlug = EVENT_SETUP_SECTIONS[EVENT_SETUP_SECTIONS.flights + 1];

    navigate(`/staff/club/${clubId}/event/${eventId}/setup/${nextSectionSlug}`);
  };

  const onChangeFlightsBy = (type: typeAction) => async () => {
    if (!event) {
      return;
    }

    const response = await editEvent(Number(clubId), {
      ...event,
      [type]: !event[type]
    });

    if (response.errors) {
      pushError('Your action could not be completed');
    }
  };

  useEffect(() => {
    if (event) {
      setUseFlights(!!event.useFlights);
    }
  }, [event]);

  if (!clubId || !eventId) {
    return <></>;
  }

  return (
    <div className="event-wizard-page form event-flights">
      <EventWizardStepTitle
        buttonText="SAVE & CONTINUE"
        buttonOnClick={nextStep}
        title="FLIGHTS"
        buttonDisabled={(event && !event.flights.length) || flightsNotSaved}
      />

      <div className="admin-form-field">
        <div className="label-row-grey">
          <div>WILL THERE BE FLIGHTS FOR THIS EVENT?</div>

          <div className="toggle">
            <Switch
              checked={useFlights}
              id="use-flights-switch"
              onChange={onChangeFlightsBy('useFlights')}
              color="primary"
            />
          </div>
        </div>
      </div>

      {useFlights && displayFlightsForIndividuals && (
        <FlightsSection setFlightsNotSaved={setFlightsNotSaved} category="i" />
      )}

      {useFlights && displayFlightsForTeams && (
        <FlightsSection setFlightsNotSaved={setFlightsNotSaved} category="t" />
      )}
    </div>
  );
};

export default EventFlights;
